module.exports = __webpack_public_path__ + "static/media/group--material-condition--dark.f19a7942.svg";